<template>
  <div
    class="flex flex-col items-center pt-16 pb-12 md:pt-20 md:pb-16 md:scale-100 scale-75"
  >
    <div class="relative">
      <!-- Halo effect -->
      <svg
        class="absolute inset-0 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        width="800"
        height="800"
        viewBox="0 0 800 800"
        style="max-width: 200%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="fill-current text-gray-400 opacity-75">
          <circle class="pulse" cx="400" cy="400" r="200" />
          <circle class="pulse pulse-1" cx="400" cy="400" r="200" />
          <circle class="pulse pulse-2" cx="400" cy="400" r="200" />
        </g>
      </svg>
      <!-- White box -->
      <svg
        class="absolute w-32 h-auto rounded-full shadow-xl"
        viewBox="0 0 128 48"
        style="width: 32%; top: 20%; right: -16%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect class="fill-current text-white" width="128" height="48" rx="24" />
      </svg>
      <!-- Globe image -->
      <img
        class="relative rounded-full shadow-xl"
        src="https://images.ctfassets.net/1b6f0wuf6ave/2egRrN7flowWcqp8lEZYkO/70b26a86137a96b2edf0aac0a6ff7341/planet.png"
        width="400"
        height="400"
        alt="Planet"
      />
      <!-- Static dots -->
      <svg
        class="absolute top-0 w-full h-auto"
        viewBox="0 0 400 400"
        style="left: 12%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter
            id="world-ill-a"
            x="-41.7%"
            y="-34.2%"
            width="183.3%"
            height="185.6%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="6"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0.439215686 0 0 0 0 0.956862745 0 0 0 0.32 0"
              in="shadowBlurOuter1"
            />
          </filter>
          <filter
            id="world-ill-c"
            x="-83.3%"
            y="-68.5%"
            width="266.7%"
            height="271.2%"
            filterUnits="objectBoundingBox"
          >
            <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              stdDeviation="6"
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
            />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0.439215686 0 0 0 0 0.956862745 0 0 0 0.32 0"
              in="shadowBlurOuter1"
            />
          </filter>
          <filter
            id="world-ill-e"
            x="-7.3%"
            y="-23.8%"
            width="114.5%"
            height="147.6%"
            filterUnits="objectBoundingBox"
          >
            <feGaussianBlur stdDeviation="2" in="SourceGraphic" />
          </filter>
          <ellipse id="world-ill-b" cx="51" cy="175.402" rx="24" ry="23.364" />
          <ellipse id="world-ill-d" cx="246" cy="256.201" rx="12" ry="11.682" />
          <linearGradient id="world-ill-f" x1="50%" y1="0%" x2="50%" y2="100%">
            <stop stop-color="black" stop-opacity="0" offset="0%" />
            <stop stop-color="black" stop-opacity=".64" offset="52.449%" />
            <stop stop-color="black" stop-opacity="0" offset="100%" />
          </linearGradient>
        </defs>
        <g transform="translate(0 -.818)" fill="none" fill-rule="evenodd">
          <use
            fill="orange"
            filter="url(#world-ill-a)"
            xlink:href="#world-ill-b"
          />
          <use fill="orange" xlink:href="#world-ill-b" />
          <use
            fill="orange"
            filter="url(#world-ill-c)"
            xlink:href="#world-ill-d"
          />
          <use fill="orange" xlink:href="#world-ill-d" />
          <ellipse
            fill-opacity=".32"
            fill="orange"
            cx="293"
            cy="142.303"
            rx="8"
            ry="7.788"
          />
          <ellipse
            fill-opacity=".64"
            fill="orange"
            cx="250"
            cy="187.083"
            rx="6"
            ry="5.841"
          />
          <ellipse
            fill-opacity=".64"
            fill="orange"
            cx="13"
            cy="233.811"
            rx="2"
            ry="1.947"
          />
          <ellipse fill="orange" cx="29" cy="114.072" rx="2" ry="1.947" />
          <path
            d="M258 256.2l87-29.204"
            stroke="#orange"
            stroke-width="2"
            opacity=".16"
            filter="url(#world-ill-e)"
          />
          <path
            d="M258 251.333c111.333-40.237 141-75.282 89-105.136M136 103.364c66.667 4.543 104.667 32.45 114 83.72"
            stroke="url(#world-ill-f)"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </svg>
      <!-- Dynamic dots -->
      <svg
        class="absolute max-w-full"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        style="width: 12%; top: 45%; left: 50%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="fill-current text-orange-400">
          <circle class="pulse pulse-mini pulse-1" cx="24" cy="24" r="8" />
          <circle class="pulse pulse-mini pulse-2" cx="24" cy="24" r="8" />
          <circle cx="24" cy="24" r="8" />
        </g>
      </svg>
      <svg
        class="absolute max-w-full"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        style="width: 12%; top: 19%; left: 46%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="fill-current text-orange-400">
          <circle class="pulse pulse-mini" cx="24" cy="24" r="8" />
          <circle class="pulse pulse-mini pulse-2" cx="24" cy="24" r="8" />
          <circle cx="24" cy="24" r="8" />
        </g>
      </svg>
      <!-- Avatars -->
      <img
        class="absolute max-w-full transform animate-float"
        src="https://images.ctfassets.net/1b6f0wuf6ave/1Rl7kcbtIKdRuyvQSNIp6M/8486f95f754d75796ebf0bc7f0347cad/planet-avatar-003.png"
        width="300"
        height="auto"
        alt="Planet avatar 03"
        style="width: 80%; top: -4%; left: -23.5%"
      />
      <img
        class="absolute max-w-full transform animate-float animation-delay-1000"
        src="https://images.ctfassets.net/1b6f0wuf6ave/5nx1hqbwqAM9WnbrDzmmSM/71e1579dd5191384ff63e75f6ce2d680/planet-avatar-005.png"
        width="256"
        height="auto"
        alt="Planet avatar 04"
        style="width: 85%; bottom: 2%; right: -55%"
      />
      <img
        class="absolute max-w-full transform animate-float animation-delay-1000"
        src="https://images.ctfassets.net/1b6f0wuf6ave/5qswe7laNiWdYsABciiKqi/d827d166c91058d23eac8f19b258424a/planet-avatar-004.png"
        alt="Planet avatar 05"
        style="width: 100%; top: 35%; right: -70%"
      />
      <img
        class="absolute max-w-full transform animate-float"
        src="https://images.ctfassets.net/1b6f0wuf6ave/5SuoKDznnM1DqzyYskmXkz/3c0cd8891659a4980f5794fc50d088a7/planet-avatar-001.png"
        width="287"
        height="86"
        alt="Planet avatar 03"
        style="width: 80%; bottom: 5%; left: -30%"
      />

      <!-- White box -->
      <svg
        class="absolute w-32 h-auto rounded-full shadow-xl"
        viewBox="0 0 128 48"
        style="width: 32%; top: 35%; left: -25%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect class="fill-current text-white" width="128" height="48" rx="24" />
      </svg>
      <!-- White box -->
      <svg
        class="absolute w-32 h-auto rounded-full shadow-xl"
        viewBox="0 0 128 48"
        style="width: 32%; top: 62%; right: -31%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect class="fill-current text-white" width="128" height="48" rx="24" />
      </svg>
    </div>
  </div>
</template>
